import {
  jb_search_clear_icon_css_default
} from "./chunk.GLJZKAOL.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  Icon
} from "./chunk.IIVCI7D3.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/icons/jb-search-clear-icon/jb-search-clear-icon.ts
var JbSearchClearIcon = class extends Icon(r) {
  render() {
    return ke`
      <svg
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        viewbox="-2 -2 25 25"
      >
        <path
          fill-opacity=".7"
          d="M6.215 13.75l3.246-3.245-3.246-3.246a.735.735 0 0 1 1.04-1.04L10.5 9.467l3.246-3.246a.735.735 0 0 1 1.04 1.04l-3.247 3.245 3.246 3.246a.735.735 0 0 1-1.04 1.04L10.5 11.543 7.254 14.79a.735.735 0 0 1-1.04-1.04zM10.5 21C16.299 21 21 16.299 21 10.5S16.299 0 10.5 0 0 4.701 0 10.5 4.701 21 10.5 21z"
        ></path>
      </svg>
    `;
  }
};
JbSearchClearIcon.styles = [reset_css_default, jb_search_clear_icon_css_default];
JbSearchClearIcon = __decorateClass([
  customElement("jb-search-clear-icon")
], JbSearchClearIcon);

export {
  JbSearchClearIcon
};
